export { default as CustomBadge } from './CustomBadge';
